<template>
  <div class="container text-center pluginHome home-gallery">
    <div class="home">
      <h1 class="heading">
        v-dialogs
      </h1>

      <p>
        <gh-btn
          class="me-2"
          href="https://github.com/terryz/v-dialogs"
          data-icon="octicon-star"
          data-show-count="true"
          aria-label="Star terryz/v-dialogs on GitHub"
        >
          Star
        </gh-btn>
        <gh-btn
          href="https://github.com/terryz/v-dialogs/fork"
          data-icon="octicon-repo-forked"
          data-show-count="true"
          aria-label="Fork terryz/v-dialogs on GitHub"
        >
          Fork
        </gh-btn>
      </p>

      <p
        align="center"
        class="gallery-container"
      >
        <!--<img :src="$store.state.baseImgUrl+ '/image/v-dialogs/v-dialogs-modal.png'" alt="v-page" >-->
        <v-gallery
          type="carousel"
          :images="list"
        />
      </p>

      <p><i18n path="dialog.projectDesc" /></p>

      <p>
        <a
          href="https://www.npmjs.com/package/v-dialogs"
          target="_blank"
          class="me-2"
        >
          <img
            src="https://img.shields.io/npm/v/v-dialogs.svg"
            alt="v-dialogs-npm"
          >
        </a>
        <a
          href="https://mit-license.org/"
          target="_blank"
        >
          <img
            src="https://img.shields.io/badge/license-MIT-brightgreen.svg"
            alt="v-dialogs-npm"
          >
        </a>
      </p>

      <p>
        <i18n path="common.jqVersion" />： <a
          href="https://github.com/TerryZ/bDialog"
          target="_blank"
        >bDialog</a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      list: [
        {
          title: 'Model dialog to any page/component',
          url: `${this.$store.state.baseImgUrl}/image/v-dialogs/v-dialogs-modal.png`
        }, {
          title: 'Message alert dialog, have info, warning, error, success, confirm types',
          url: `${this.$store.state.baseImgUrl}/image/v-dialogs/v-dialogs-alert.png`
        }, {
          title: 'The full screen mask',
          url: `${this.$store.state.baseImgUrl}/image/v-dialogs/v-dialogs-mask.png`
        }, {
          title: 'Toast dialog, 6 corner and 4 message types',
          url: `${this.$store.state.baseImgUrl}/image/v-dialogs/v-dialogs-toast.png`
        }
      ]
    }
  }
}
</script>
